import React from 'react';

const SeveritySelector = ({ options, value, onSelect, singleSelect = false }) => {
  const handleButtonClick = (option) => {
    let newSelection;
    if (singleSelect) {
      // If single-select, toggle the value or select it
      newSelection = value[0] === option ? [] : [option];
    } else {
      // If multi-select, add or remove the value
      newSelection = value.includes(option)
        ? value.filter((val) => val !== option)
        : [...value, option];
    }
    onSelect(newSelection);
  };

  return (
    <div className="severity-selector">
      {options.map((option) => (
        <button
          key={option}
          className={`severity-btn ${value.includes(option) ? 'active' : ''}`}
          onClick={() => handleButtonClick(option)}
        >
          {option}
        </button>
      ))}
    </div>
  );
};

export default SeveritySelector;